The confidence in the returned job category based on the suggestion input.

This is a floating point value ranging from 0 (lowest) to 1 (highest).
